module.exports = __webpack_public_path__ + "img/4-4anquan.6cbea301.png";